/* tslint:disable */
import {
  AnnualBreakdown
} from '../index';

declare var Object: any;
export interface VoteHeadAllocationInterface {
  "amount": number;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  "annual_breakdown_id"?: number;
  annualBreakdown?: AnnualBreakdown;
}

export class VoteHeadAllocation implements VoteHeadAllocationInterface {
  "amount": number;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  "annual_breakdown_id": number;
  annualBreakdown: AnnualBreakdown;
  constructor(data?: VoteHeadAllocationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `VoteHeadAllocation`.
   */
  public static getModelName() {
    return "VoteHeadAllocation";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of VoteHeadAllocation for dynamic purposes.
  **/
  public static factory(data: VoteHeadAllocationInterface): VoteHeadAllocation{
    return new VoteHeadAllocation(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'VoteHeadAllocation',
      plural: 'VoteHeadAllocations',
      path: 'VoteHeadAllocations',
      properties: {
        "amount": {
          name: 'amount',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
        "annual_breakdown_id": {
          name: 'annual_breakdown_id',
          type: 'number'
        },
      },
      relations: {
        annualBreakdown: {
          name: 'annualBreakdown',
          type: 'AnnualBreakdown',
          model: 'AnnualBreakdown'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/VoteHeadAllocation.ts